<div class="header-container header-container-desktop">
    <div class="header-left-pre-side"></div>
    <div class="header-inner-container">
        <div class="header-left-side">
            <div class="header-logo" *ngIf="logoSrc">
                <img [src]="logoSrc" alt="Logo" (error)="onLogoError($event)"/>
            </div>
        </div>
        <div class="header-delimeter-parts"></div>
        <div class="header-right-side">
            <ng-container *ngIf="brokerInfoExists">
                <div class="header-agent-container">
                    <div class="header-your-agent">YOUR AGENT</div>
                    <i class="fa-regular fa-circle-user"></i>
                    <div class="header-profile-name" *ngIf="brokerNameExists">{{ brokerInfo!.name }}</div>
                </div>
                <div class="header-delimeter"></div>
                <a class="header-phone-container" [href]="phoneHref">
                    <i class="fa-regular fa-phone-volume"></i>
                    <div class="header-phone-number" *ngIf="brokerPhoneExists">{{ brokerInfo?.phone }}</div>
                </a>
                <div class="header-delimeter"></div>
                <a class="e-mail-btn" *ngIf="brokerEmailExists" [href]="emailHref" >
                    <span>
                        E-Mail Agent >
                    </span>
                </a>
            </ng-container>
        </div>
    </div>
    <div class="header-right-pre-side"></div>
</div>

<div class="header-container header-container-mobile">
    <div class="header-inner-container">
        <div class="header-left-side">
            <div class="header-logo" *ngIf="logoSrc">
                <img [src]="logoSrc" alt="Logo" (error)="onLogoError($event)"/>
            </div>
            <a class="e-mail-btn" *ngIf="brokerInfoExists && brokerEmailExists" [href]="emailHref">
                <span>
                    E-Mail Agent >
                </span>
            </a>
        </div>
        <div class="header-right-side">
            <ng-container *ngIf="brokerInfoExists">
                <div class="header-your-agent">YOUR AGENT</div>
                <div class="header-agent-container">
                    <i class="fa-regular fa-circle-user"></i>
                    <div class="header-profile-name" *ngIf="brokerNameExists">{{ brokerInfo?.name }}</div>
                    <div class="header-delimeter"></div>
                </div>

                <a class="header-phone-container" [href]="phoneHref">
                    <i class="fa-regular fa-phone-volume"></i>
                    <div class="header-phone-number" *ngIf="brokerPhoneExists">{{ brokerInfo?.phone }}</div>
                </a>
            </ng-container>
        </div>
    </div>
</div>
<div class="pb-3">
    <app-error-page
        *ngIf="errorMessage"
        [errorMessage]="errorMessage">
    </app-error-page>
    <router-outlet *ngIf="!errorMessage"></router-outlet>
</div>

<!-- Error Modal for non-fatal errors -->
<app-error-modal></app-error-modal>
